import ViewPosts from "./components/ViewPosts";

function App() {
  return <ViewPosts path="/" />;
}

export default App;
